(function () {
  var STORAGE_KEY = 'torflux-theme-mode';

  function applyMode(mode) {
    document.documentElement.setAttribute('data-theme-mode', mode);
  }

  var stored = null;
  try {
    stored = localStorage.getItem(STORAGE_KEY);
  } catch (e) {}
  applyMode(stored === 'light' ? 'light' : 'dark');

  function buildToggle() {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'torflux-theme-toggle';
    btn.setAttribute('aria-label', 'Toggle light and dark mode');
    btn.innerHTML =
      '<svg class="torflux-icon-moon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>' +
      '<svg class="torflux-icon-sun" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/></svg>';

    btn.addEventListener('click', function () {
      var current = document.documentElement.getAttribute('data-theme-mode');
      var next = current === 'light' ? 'dark' : 'light';
      applyMode(next);
      try {
        localStorage.setItem(STORAGE_KEY, next);
      } catch (e) {}
    });

    document.body.appendChild(btn);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildToggle);
  } else {
    buildToggle();
  }
})();
